/**
 * Feature rows of the plan comparison view, grouped as in the design.
 *
 * Each cell is either `true` (included), `false` (not included) or a translation
 * key rendered as text. Labels reuse the same keys as the plan cards, so the two
 * views cannot drift apart.
 *
 * The Limits group is not here: its values are the plan's own quota and seats
 * from `plans.js`, and the view builds that group from the same source the cards
 * use rather than restating the numbers.
 *
 * @typedef {Object} ComparisonRow
 * @property {string} labelKey
 * @property {boolean|string} dppTextile
 * @property {boolean|string} enterprise
 *
 * @typedef {Object} ComparisonGroup
 * @property {string} titleKey
 * @property {ComparisonRow[]} rows
 *
 * @type {ComparisonGroup[]}
 */
export default [
  {
    titleKey: 'plans_group_passport_pages',
    rows: [
      { labelKey: 'plans_feat_passport_page', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_gs1_digital_link', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_build_pages', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_edit_anytime', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_multilingual', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_image_library', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_consumer_questions', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_custom_experiences', dppTextile: false, enterprise: true }
    ]
  },
  {
    titleKey: 'plans_group_qr_printing_ops',
    rows: [
      { labelKey: 'plans_feat_print_ready_qr', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_branded_qr', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_copy_detection', dppTextile: false, enterprise: true },
      { labelKey: 'plans_feat_serialisation', dppTextile: false, enterprise: true },
      { labelKey: 'plans_feat_print_partner_qa', dppTextile: false, enterprise: true },
      { labelKey: 'plans_extra_amazon_transparency', dppTextile: false, enterprise: true },
      { labelKey: 'plans_extra_bulk_upload', dppTextile: false, enterprise: true }
    ]
  },
  {
    titleKey: 'plans_group_traceability',
    rows: [
      { labelKey: 'plans_feat_traceability', dppTextile: false, enterprise: true },
      { labelKey: 'plans_feat_counterfeit_monitor', dppTextile: false, enterprise: true },
      { labelKey: 'plans_row_domains', dppTextile: 'plans_value_basic_redirection', enterprise: 'plans_value_multiple_domains' }
    ]
  },
  {
    titleKey: 'plans_group_analytics_support',
    rows: [
      { labelKey: 'plans_feat_scan_insights', dppTextile: true, enterprise: true },
      { labelKey: 'plans_feat_bi_exports', dppTextile: false, enterprise: true },
      { labelKey: 'plans_feat_users_sso_2fa', dppTextile: false, enterprise: true },
      { labelKey: 'plans_row_support', dppTextile: 'plans_value_support_email', enterprise: 'plans_value_support_dedicated' }
    ]
  }
]
